import * as XLSX from 'xlsx';

// Exports the exact current jspreadsheet view as an .xlsx file:
//   - column titles/order/widths are taken from the rendered columns
//   - rows must be in grid order (i.e. resynced via the onsort handler)
//   - an active column filter/search inside the grid is honored via
//     worksheet.results (array of visible row indexes, null when unfiltered)
// Returns the number of exported rows.
export function exportJssView({ filename, headers, columnWidths, rows, worksheet }) {
  const visibleIndexes = worksheet && Array.isArray(worksheet.results)
    ? worksheet.results
    : null;
  const exportRows = visibleIndexes
    ? visibleIndexes.map(index => rows[index]).filter(row => row !== undefined)
    : rows;

  const sheet = XLSX.utils.aoa_to_sheet([headers].concat(exportRows));
  sheet['!cols'] = headers.map((title, index) => {
    const pixels = columnWidths && columnWidths[index];
    const wch = pixels ? Math.round(pixels / 8) : title.length + 2;
    return { wch: Math.max(8, Math.min(60, wch)) };
  });

  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, sheet, 'Export');
  XLSX.writeFile(book, filename);

  return exportRows.length;
}
